import { get } from "./request";
import { downloadAttachmentAs } from "./downloadFile";

/**
 * 下载最新 App APK
 * @param {Object} [options]
 * @param {(phase: 'preparing' | 'downloading') => void} [options.onPhase]
 * @param {(payload: { loaded: number, total: number, percent: number | null }) => void} [options.onProgress]
 * @returns {Promise<'ok' | 'no-version' | 'no-url' | 'fallback'>}
 */
export async function downloadLatestAppApk({ onPhase, onProgress } = {}) {
  onPhase?.("preparing");

  const res = await get("/user/appVersion/getLastVersion");
  const versionData = res?.data;
  const attachmentUuid =
    versionData?.attachmentUuid ?? versionData?.attachmentUUID ?? "";

  if (!attachmentUuid) {
    return "no-version";
  }

  onPhase?.("downloading");
  const result = await downloadAttachmentAs(attachmentUuid, { onProgress });
  if (result === "no-url") return "no-url";
  return result === "fallback" ? "fallback" : "ok";
}
